import * as angular from "angular";
import { EmploymentStatusDataProvider } from "../../data-provider/employment-status.dp";
import { FieldDataProvider } from "../../data-provider/field.dp";
import { DialogUtils } from "../../helper/dialog.helper";

let BulkEditComponent = {
    selector: "vcBulkEdit",
    templateUrl: "/angular/components/people/bulk-edit.component.html",
    bindings: {
        numItems: "=",
    },
    controller: class BulkEditController {
        // * bindings for typescript compiler *
        public numItems: any;
        // ************************************

        private itemText: string;
        private fields: any;
        private readOnlyFieldNote = "This field is read-only";
        private employmentstatuses = [];
        private nameFields = [
            {
                name: "First name",
                type: "Text",
                hokey: "fname",
                required: "1",
            },
            {
                name: "Last name",
                type: "Text",
                hokey: "lname",
                required: "1",
            },
        ];
        private fieldEdit: any = {
            value: null,
        };

        private dialog: DialogUtils;
        private $filter: any;

        private fieldDataProvider: FieldDataProvider;
        private employmentStatusDataProvider: EmploymentStatusDataProvider;

        constructor(
            $filter: any,
            DialogUtils: DialogUtils,
            FieldDataProvider: FieldDataProvider,
            EmploymentStatusDataProvider: EmploymentStatusDataProvider
        ) {
            this.dialog = DialogUtils;
            this.$filter = $filter;

            this.fieldDataProvider = FieldDataProvider;
            this.employmentStatusDataProvider = EmploymentStatusDataProvider;

            this.fieldDataProvider.getAllFields(true).then((fields: any) => {
                this.fields = fields.nonpriority.concat(
                    fields.priority.concat(fields.priorityDisabled)
                );
            });

            this.employmentStatusDataProvider
                .all()
                .then((statuses: object[]) => {
                    this.employmentstatuses = statuses;
                });
        }

        $onInit() {
            this.itemText =
                this.numItems > 1
                    ? `${this.numItems} contacts`
                    : `${this.numItems} contact`;
        }

        setSelectedField(field: any) {
            this.fieldEdit.field = field;
            this.fieldEdit.value = null;
        }

        isReadOnly(field: any): boolean {
            return angular.isDefined(field.readonly) && field.readonly == "1";
        }

        isRequired(field: any): boolean {
            return angular.isDefined(field.required) && field.required == "1";
        }

        validFieldOption(field: any): boolean {
            if (
                field.cfid &&
                (field.type == "Checklist" || field.type == "Multiple Choice")
            ) {
                return field.options.length > 0;
            } else if (field.cfid && field.cftid == 7) {
                return false;
            }
            return true;
        }

        clearAll() {
            this.fieldEdit.field.options.forEach((option: any) => {
                if (angular.isDefined(option.selected) && option.selected) {
                    option.selected = false;
                }
            });
            this.fieldEdit.value = this.isRequired(this.fieldEdit.field)
                ? null
                : "";
        }

        selectCheckbox(option: any): void {
            if (
                this.fieldEdit.value == null ||
                !Array.isArray(this.fieldEdit.value)
            ) {
                this.fieldEdit.value = [];
            }

            if (!option.selected) {
                const index = this.fieldEdit.value.indexOf(option.cfoid);
                if (index > -1) {
                    this.fieldEdit.value.splice(index, 1);
                }
            } else {
                this.fieldEdit.value.push(option.cfoid);
            }
        }

        confirm(): void {
            const edit = this.dialog
                .confirm()
                .title(`Bulk edit field`)
                .htmlContent(
                    `Edit the "${this.fieldEdit.field.name}" field for ${this.itemText}? <br/> <b>This action cannot be undone.</b>`
                )
                .multiple(true)
                .ok("Confirm")
                .cancel("Cancel");
            this.dialog.show(edit).then(() => {
                if (this.fieldEdit.field.hokey == "dob") {
                    this.fieldEdit.value = this.$filter("date")(
                        this.fieldEdit.value,
                        "yyyy-MM-dd"
                    );
                }
                this.dialog.hide(this.fieldEdit);
            });
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("people")
    .component(BulkEditComponent.selector, BulkEditComponent);
